import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FdaComponent } from './fda.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FdaRoutingModule } from './fda-routing.module';

@NgModule({
  declarations: [FdaComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FdaRoutingModule,
  ],
})
export class FdaModule {}
